import { render, staticRenderFns } from "./FinishedButton.vue?vue&type=template&id=10fc60de&"
import script from "./FinishedButton.vue?vue&type=script&lang=ts&"
export * from "./FinishedButton.vue?vue&type=script&lang=ts&"
import style0 from "./FinishedButton.vue?vue&type=style&index=0&id=10fc60de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports